import "@/App.css";
import "@/i18n";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { CompareProvider } from "@/contexts/CompareContext";

import Home from "@/pages/Home";
import Search from "@/pages/Search";
import ListingDetail from "@/pages/ListingDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import NewListing from "@/pages/NewListing";
import Favorites from "@/pages/Favorites";
import MapPage from "@/pages/MapPage";
import PaymentsSuccess from "@/pages/PaymentsSuccess";
import Messages from "@/pages/Messages";
import AuthCallback from "@/pages/AuthCallback";
import Kyc from "@/pages/Kyc";
import AdminKyc from "@/pages/AdminKyc";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminHome from "@/pages/AdminHome";
import AdminModeration from "@/pages/AdminModeration";
import AdminSettings from "@/pages/AdminSettings";
import AdminUsers from "@/pages/AdminUsers";
import Agencies from "@/pages/Agencies";
import Agency from "@/pages/Agency";
import ForAgencies from "@/pages/ForAgencies";
import Compare from "@/pages/Compare";
import { CompareBar } from "@/components/CompareBar";

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    }
  }, []);
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <CompareProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/search" element={<Search />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/listings/:id" element={<ListingDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/new" element={<NewListing />} />
                <Route path="/dashboard/edit/:id" element={<NewListing />} />
                <Route path="/dashboard/kyc" element={<Kyc />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/messages/:listingId/:peerId" element={<Messages />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/payments/success" element={<PaymentsSuccess />} />
                <Route path="/admin" element={<AdminHome />} />
                <Route path="/admin/kyc" element={<AdminKyc />} />
                <Route path="/admin/analytics" element={<AdminAnalytics />} />
                <Route path="/admin/moderation" element={<AdminModeration />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/settings" element={<AdminSettings />} />
                <Route path="/agences" element={<Agencies />} />
                <Route path="/agence/:slug" element={<Agency />} />
                <Route path="/pour-agences" element={<ForAgencies />} />
                <Route path="/compare" element={<Compare />} />
              </Routes>
              <CompareBar />
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </CompareProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
